import React from "react"
import Layout from "../components/layout"
import { graphql, Link } from "gatsby"
import { Container } from "reactstrap"
import Seo from "../components/seo"
import marked from "marked"
import { getImage } from "gatsby-plugin-image"
import { convertToBgImage } from "gbimage-bridge"
import BackgroundImage from "gatsby-background-image"

class BlogTemplate extends React.Component {
  render() {
    const { post } = this.props.data
    const { previous, next } = this.props.pageContext
    // console.log(post)
    // console.log(post.body)
    const ggimage = getImage(
      post.mainImage !== null ? post?.mainImage?.asset?.gatsbyImageData : null
    )
    const convertggimage = convertToBgImage(ggimage)
    return (
      <Layout>
        <Seo title={post.title} description=" " />

        <BackgroundImage
          Tag="div"
          className="page-headline blog-page bg-blog-tmp"
          {...convertggimage}
          // style={{
          //   backgroundImage: `url(${
          //     post.mainImage !== null || undefined
          //       ? post.mainImage.asset.fluid.src
          //       : null
          //   })`,
          // }}
        >
          <div className="bg-blog-tmp-wrap" />
          <div className="container">
            <div className="section-heading text-center">
              <h6 className="font-weight-bold text-uppercase text-white-50 flair">
                Blog
              </h6>
              <h1>
                <strong>{post.title}</strong>
                <br />
              </h1>
              <span className="text-white-50 small">
                <i className="fa fa-calendar-o pr-1" />
                {post.publishedAt}
              </span>
            </div>
          </div>
        </BackgroundImage>

        <div className="page-content">
          <Container>
            <div className="row justify-content-center mb-5">
              <div className="col-md-10 m-auto">
                <div
                  dangerouslySetInnerHTML={{
                    __html: marked(post.body),
                  }}
                />
              </div>
            </div>
            <div className="blog-nav">
              <div className="row">
                <div className="col-md-6 text-md-left">
                  {previous ? (
                    <div>
                      <span className="font-weight-bold text-uppercase text-muted d-block small">
                        Previous
                      </span>
                      <Link
                        title="blog item prev"
                        to={`/blog/${previous.slug.current}`}
                      >
                        {previous.title}
                      </Link>
                    </div>
                  ) : null}
                </div>
                <div className="col-md-6 text-md-right">
                  {next ? (
                    <div>
                      <span className="font-weight-bold text-uppercase text-muted d-block small">
                        next
                      </span>
                      <Link
                        title="blog item next"
                        to={`/blog/${next.slug.current}`}
                      >
                        {next.title}
                      </Link>
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
          </Container>
        </div>
      </Layout>
    )
  }
}

export default BlogTemplate

export const blogQuery = graphql`
  query BlogPostTemplateQuery($id: String!) {
    post: sanityPost(id: { eq: $id }) {
      id
      body
      mainImage {
        asset {
          gatsbyImageData(
            placeholder: BLURRED
            layout: CONSTRAINED
            fit: FILL
            formats: [AUTO, WEBP, AVIF]
          )
        }
      }
      slug {
        current
      }
      publishedAt(formatString: "MMMM DD, YYYY")
      title
      metaDescription
    }
  }
`
